export const environment = {
  production: false,
  envName: 'test',
  apiUrl: 'https://api-test.certiports.com',  // Backend API TEST avec domaine personnalisé
  projectId: 'vps-certiport',
  region: 'europe-west1',
  features: {
    debugMode: true,
    mockData: false,
    enableAnalytics: false,
    enableErrorReporting: true
  },
  api: {
    timeout: 30000,
    retryAttempts: 3
  },
  logging: {
    level: 'debug',
    enableConsoleLog: true
  }
};